import {
  IStandardPredictionRequest,
  IModifiedData,
  IStandardPredictionPostRequest,
  IStandardPredictionFilter,
} from '../../core/interfaces/standard-prediction.interface';

export class GetStandardPrediction {
  static readonly type = '[StandardPrediction] Get Standard Prediction';
  constructor(public payload: IStandardPredictionRequest) {}
}

export class UpdateModifiedData {
  static readonly type = '[StandardPrediction] Update Modified Data';
  constructor(public payload: IModifiedData) {}
}

export class GetStandardPredictionEdit {
  static readonly type = '[StandardPrediction] Get Standard Prediction Edit';
  constructor(public payload: IStandardPredictionPostRequest) {}
}

export class GetStandardPredictionTemporal {
  static readonly type =
    '[StandardPrediction] Get Standard Prediction Temporal';
  constructor(public payload: string) {}
}

export class GetGenerationStandardPredictionTemporal {
  static readonly type =
    '[StandardPrediction] Get Generation Standard Prediction Temporal';
  constructor(public payload: string) {}
}

export class ApplyPredictionPercentages {
  static readonly type = '[StandardPrediction] Apply Prediction Percentages';
}

export class PostGeneratePrediction {
  static readonly type = '[StandardPrediction] Post Generate Prediction';
  constructor(public payload: IStandardPredictionPostRequest) {}
}

export class SetSelectedTab {
  static readonly type = '[StandardPrediction] Set Selected Tab';
  constructor(public payload: number) {}
}

export class SetCurrentFilters {
  static readonly type =
    '[StandardPrediction] Set Current Filters (ignore dates)';
  constructor(public payload: IStandardPredictionFilter | null) {}
}

export class ResetModifiedData {
  static readonly type = '[StandardPrediction] Reset Modified Data';
}

export class SetRangeDate {
  static readonly type = '[StandardPrediction] Set Range Date';
  constructor(public payload: { startDate: string; endDate: string }) {}
}
